





























import { defineComponent, ref, useContext } from "@nuxtjs/composition-api";
import { isEmpty } from "lodash-es";
import { useCms, useGtm } from "~/composables";
import Utils from "~/helpers/utils";
import { getLocalizedPath } from "~/helpers/getLocalizedPath";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("VSelect", vSelect);

export default defineComponent({
  name: "SearchBar",
  components: {},
  props: {
    page: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { app: { i18n } } = useContext();
    const { eventSearchResultsCTA } = useGtm();
    const { preventXSSAttacks, preventSqlAttacks } = Utils();
    const searchOptions = ref([]);
    const { searchCms } = useCms();

    let lastInput = null;
    const fetchOptions = (search, loading) => {
      const nodeId = props.page["node_id"];
      const searchKeyword = preventXSSAttacks(search.trim());
      const containSqlKeyWords = (preventSqlAttacks(searchKeyword));
      if (lastInput) {
        clearTimeout(lastInput);
      }
      lastInput = setTimeout(async () => {
        if (searchKeyword.length && !containSqlKeyWords) {
          loading(true);
          const data = await searchCms({
            keyword: searchKeyword,
            nodeId: nodeId,
          });
          searchOptions.value = data["data"];
          loading(false);
          eventSearchResultsCTA({
            "Search Category": "Product Search",
            "Label": "Product Search",
            "SearchTerm": searchKeyword,
            "SearchResults": data["data"],
            "itemCount": data['total_count'],
          });
        } else {
          searchOptions.value = [];
        }
      }, 300);
    };
    const dropdownShouldOpen = (VueSelect) => {
      VueSelect.search = preventXSSAttacks(VueSelect.search);
      if (!isEmpty(searchOptions.value)) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    };
    const handlers = (map, vm) => ({
      ...map,
      8: (e) => {
        setTimeout(() => {
          if (e.key === "Backspace" && vm.search.length === 0) {
            searchOptions.value = [];
          }
        }, 50);
      },
    });
    const clearSearchOnBlur = ({ clearSearchOnSelect, multiple }) => {
      return clearSearchOnSelect && !multiple;
    };

    return {
      handlers,
      searchOptions,
      fetchOptions,
      dropdownShouldOpen,
      clearSearchOnBlur,
      getLocalizedPath,
      i18n,
    };
  },
});
